import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import './AdminLogin.css';

function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [rateLimited, setRateLimited] = useState(false);
    const navigate = useNavigate();
    const { login, isLoggedIn, userInfo, refreshCsrfToken, csrfToken } = useContext(AuthContext);

    useEffect(() => {
        if (!csrfToken) {
            refreshCsrfToken();
        }
    }, [csrfToken, refreshCsrfToken]);

    useEffect(() => {
        if (isLoggedIn && userInfo) {
            const isAdmin = ['admin', 'warehouse', 'sales'].includes(userInfo.role);
            if (isAdmin) {
                navigate('/admin/dashboard');
            }
        }
    }, [isLoggedIn, userInfo, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (rateLimited) {
            setErrorMessage('Too many login attempts. Please try again later.');
            return;
        }

        setLoading(true);
        setErrorMessage('');

        const credentials = {
            Username: username,
            Password: password,
        };

        try {
            const user = await login(credentials, "admin");
            if (user && ['admin', 'warehouse', 'sales'].includes(user.role)) {
                navigate('/admin/dashboard');
            }
        } catch (error) {
            if (error.status === 429) {
                setRateLimited(true);
                setErrorMessage('Too many login attempts. Please try again later.');
            } else if (error.message) {
                setErrorMessage(error.message);
            } else {
                setErrorMessage('Invalid username or password. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="admin-login-loading">
                <div className="admin-login-spinner"></div>
            </div>
        );
    }

    return (
        <div className="admin-login-container">
            {/* Decorative elements */}
            <div className="admin-login-decoration admin-login-decoration-1"></div>
            <div className="admin-login-decoration admin-login-decoration-2"></div>
            <div className="admin-login-box">
                <div className="admin-login-header">
                    <div className="admin-login-logo-container">
                        <img
                            src="./company-logo.png"
                            alt="Company Logo"
                            className="admin-login-company-logo"
                        />
                    </div>
                    <h1 className="admin-login-title">Admin Portal</h1>
                    <p className="admin-login-subtitle">Sign in to access the dashboard</p>
                </div>
                <div className="admin-login-home-link">
                    <a href="/" className="admin-login-home-button">
                        <span className="admin-login-home-icon">🏠</span>
                        <span>Return to Homepage</span>
                    </a>
                </div>
                <div className="admin-login-form-container">
                    <form onSubmit={handleSubmit} className="admin-login-form">
                        <div className="admin-login-input-group">
                            <input
                                type="text"
                                className="admin-login-input"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                            <div className="admin-login-input-icon"><i className="fas fa-user-tie" aria-hidden="true"></i>
                            </div></div>
                        <div className="admin-login-input-group">
                            <input
                                type="password"
                                className="admin-login-input"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <div className="admin-login-input-icon"><i className="fas fa-unlock-alt" aria-hidden="true"></i></div>
                        </div>
                        {errorMessage && (
                            <div className="admin-login-error">
                                {errorMessage}
                            </div>
                        )}
                        <button type="submit" className="admin-login-button">
                            Sign In
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;